import { useIntl } from "react-intl"
import { OrderSpecification } from "../../../../../../models/IGroupSummary"
import { makeStyles } from '@material-ui/core/styles'
import { Elements, ExpandingSection, ReportTable, TwoColRow } from "@tfo/common"
import GroupOrderSpecificationCheckpoints from "./GroupOrderSpecificationCheckpoints"

type GroupOrderSpecificationParams = {
    specification: OrderSpecification
    summary: string
}

const { Heading4, Paragraph,  } = Elements

const useOrderSpecificationStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1em',
        marginBottom: '4em',
        width: '100%'
    },
    headerSpacing: {
        marginBottom: '0.5em'
    },
    rowSpacing: {
        marginBottom: '1.5em'
    },
    summary: {
        paddingTop: '5em',
        marginBottom: '123px', //same spacing as for single reports
        '@media print': {
            display: 'none'
        }
    },
    specificationSpacing: {
        marginBottom: '1em',
    }
})

const GroupOrderSpecification = ({ specification, summary }: GroupOrderSpecificationParams) => {


    const styles = useOrderSpecificationStyles()
    const intl = useIntl()
    return <div className={styles.container}>
        <div className={styles.summary}>
            <Heading4 className={styles.headerSpacing}>
                {intl.formatMessage({ id: 'readreport.label.reportSummary' })}
            </Heading4>
            <Paragraph>
                {summary || intl.formatMessage({ id: 'defaultValue.reportSummary' })}
            </Paragraph>
        </div>
        <div>
            <Heading4 className={styles.headerSpacing}>
                {intl.formatMessage({ id: 'readreport.label.orderspecifications' })}
            </Heading4>
            <ExpandingSection
                caption={intl.formatMessage({ id: 'readreport.label.orderspecifications' })}>
            <ReportTable className={`ReadReport__Table TwoColTable ${styles.specificationSpacing}`}>
                <TwoColRow
                    label={intl.formatMessage({ id: 'archived.report.label.report-count' })}
                    value={intl.formatNumber(specification.numberOfReports)}
                />
                <TwoColRow
                    label={intl.formatMessage({ id: 'archived.report.label.report-discepancy-count' })}
                    value={intl.formatNumber(specification.numberOfReportsWithDiscrepancies)}
                />
                <TwoColRow
                    label={intl.formatMessage({ id: 'readreport.label.ordering.date' })}
                    value={`${intl.formatDate(specification.created)}`}
                />
                <TwoColRow
                    label={intl.formatMessage({ id: 'archived.report.lastApproval' })}
                    value={specification.approval
                        ? `${intl.formatDate(specification.approval)}`
                        : '-'}
                />
                <TwoColRow
                    className={styles.rowSpacing}
                    label={intl.formatMessage({ id: 'readreport.label.delivered' })}
                    value={specification.delivered
                        ? `${intl.formatDate(specification.delivered)}`
                        : '-'}
                />
                <TwoColRow
                    label={intl.formatMessage({ id: 'readreport.label.customer' })}
                    value={specification.companyName}
                />
                <TwoColRow
                    label={intl.formatMessage({ id: 'readreport.label.client' })}
                    value={specification.orderer}
                />
                <TwoColRow
                    label={intl.formatMessage({ id: 'readreport.label.reportpackage' })}
                    value={specification.reportPackageName}
                />
                {specification.reportRecipients.map((recipient, index) => (
                    <TwoColRow
                        key={index}
                        label={!index && intl.formatMessage({ id: 'archived.report.label.report-recipients' })}
                        value={recipient.firstName + ' ' + recipient.lastName}
                    />
                ))}
                
            </ReportTable>
                        </ExpandingSection>

            <ExpandingSection
                caption={intl.formatMessage({ id: 'readreport.label.controlpoints' })}>
                <GroupOrderSpecificationCheckpoints checkpoints={specification.checkpoints.map(x => ({ checkpointType: x.type, category: x.category }))} />
            </ExpandingSection>
        </div>
    </div>
}

export default GroupOrderSpecification